import { render } from "./CheckingOrder.vue?vue&type=template&id=5601370e"
import script from "./CheckingOrder.vue?vue&type=script&lang=js"
export * from "./CheckingOrder.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__